import VueRouter from 'vue-router';
import Vue from 'vue';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/:slide',
      redirect: to => ({ path: '/', query: { slide: to.params.slide }})
    }
  ]
});

export default router;